import { render } from "./StarInput.vue?vue&type=template&id=196a7cf4&scoped=true&ts=true"
import script from "./StarInput.vue?vue&type=script&lang=ts"
export * from "./StarInput.vue?vue&type=script&lang=ts"

import "./StarInput.vue?vue&type=style&index=0&id=196a7cf4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a7cf4"]])

export default __exports__